module.exports = __webpack_public_path__ + "static/media/car.95411458.svg";